import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52f88d1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "d-flex flex-wrap" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex align-center"
}
const _hoisted_4 = {
  key: 1,
  class: "d-flex align-center"
}
const _hoisted_5 = {
  key: 2,
  class: "d-flex align-center"
}
const _hoisted_6 = {
  key: 3,
  class: "d-flex align-center"
}
const _hoisted_7 = {
  key: 4,
  class: "d-flex align-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "buttons-page",
  class: "d-flex"
}, null, -1))
const _hoisted_9 = { class: "d-flex align-center" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { MoleculeModalAlert } from '../molecules';
import { DashboardIcon, LogoutIcon, AtomButtonBar, AgentsIcon, SettingIcon, RelatoryIcon } from '../atoms';
import { Authentication } from '@/store';
import { onMounted } from 'vue';
import BedIcon from '../atoms/icons/BedIcon.vue';

type MenuTitle = 'Dashboard' | 'Agentes' | 'Relatórios' | 'Leitos' | 'Configurações';
interface MenuItem {
  title: MenuTitle;
  hovered: boolean;
}

const color = 'rgba(255, 255, 255, 0.4)';
const colorHover = '#FFFFFFFF';

export default /*#__PURE__*/_defineComponent({
  __name: 'OrganismsBar',
  setup(__props) {

let logo = '';
const router = useRouter();
const showModal = ref<boolean>(false);
const menuItems = ref<MenuItem[]>([
  {
    title: 'Dashboard',
    hovered: false,
  },
  {
    title: 'Agentes',
    hovered: false,
  },
  {
    title: 'Relatórios',
    hovered: false,
  },
  {
    title: 'Leitos',
    hovered: false,
  },
  {
    title: 'Configurações',
    hovered: false,
  },
]);

const toggleHover = (menu: MenuTitle, value: boolean) => {
  const index = menuItems.value.findIndex((item) => item.title == menu);

  if (index === -1) return;

  menuItems.value[index].hovered = value;
};

onMounted(() => {
  const searchLogo = localStorage.getItem('logo');
  if (searchLogo !== null) {
    logo = searchLogo.replace(/^"(.*)"$/, '$1');
  }
})

function handleLogout() {
  Authentication.actions.logout();
  router.push({ name: 'Login' });
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app_bar, {
      app: "",
      height: "100",
      style: {"padding":"0 50px 0 55px","background":"linear-gradient(180deg, var(--primary-c600) 0%, var(--primary-c800) 100%)"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          class: "mr-15",
          src: _unref(logo),
          width: "40"
        }, null, 8, _hoisted_1),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: item.title,
              to: { name: item.title },
              class: _normalizeClass(["menu-option", { active: _ctx.$route.name == item.title }]),
              onMouseover: ($event: any) => (toggleHover(item.title, true)),
              onMouseleave: ($event: any) => (toggleHover(item.title, false))
            }, {
              default: _withCtx(() => [
                (item.title == 'Dashboard')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_unref(DashboardIcon), {
                        class: "mr-2",
                        color: _ctx.$route.name == item.title ? colorHover : item.hovered ? colorHover : color
                      }, null, 8, ["color"]),
                      _createTextVNode(" " + _toDisplayString(item.title), 1)
                    ]))
                  : _createCommentVNode("", true),
                (item.title == 'Agentes')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_unref(AgentsIcon), {
                        class: "mr-2",
                        color: _ctx.$route.name == item.title ? colorHover : item.hovered ? colorHover : color
                      }, null, 8, ["color"]),
                      _createTextVNode(" " + _toDisplayString(item.title), 1)
                    ]))
                  : _createCommentVNode("", true),
                (item.title == 'Relatórios')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_unref(RelatoryIcon), {
                        class: "mr-2",
                        color: _ctx.$route.name == item.title ? colorHover : item.hovered ? colorHover : color
                      }, null, 8, ["color"]),
                      _createTextVNode(" " + _toDisplayString(item.title), 1)
                    ]))
                  : _createCommentVNode("", true),
                (item.title == 'Leitos')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(BedIcon, {
                        class: "mr-2",
                        color: _ctx.$route.name == item.title ? colorHover : item.hovered ? colorHover : color
                      }, null, 8, ["color"]),
                      _createTextVNode(" " + _toDisplayString(item.title), 1)
                    ]))
                  : _createCommentVNode("", true),
                (item.title == 'Configurações')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_unref(SettingIcon), {
                        class: "mr-2",
                        color: _ctx.$route.name == item.title ? colorHover : item.hovered ? colorHover : color
                      }, null, 8, ["color"]),
                      _createTextVNode(" " + _toDisplayString(item.title), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["to", "class", "onMouseover", "onMouseleave"]))
          }), 128))
        ]),
        _createVNode(_component_v_spacer),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(AtomButtonBar), {
            background: "transparent",
            class: "pa-0",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = true))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(LogoutIcon))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(MoleculeModalAlert), {
      "show-alert-confirm": showModal.value,
      icon: 'AlertLogoutIcon',
      text: "Deseja sair da sua conta?",
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (showModal.value = false)),
      onConfirm: handleLogout
    }, null, 8, ["show-alert-confirm"])
  ], 64))
}
}

})